import { regionPaths, useApi, useProvinces, type Regency } from '@lib/api';

/**
 * The provinces, and the regencies/cities of `provinceCode` (none without one). Both lists are fixed and small
 * (38 provinces, at most a few dozen regencies each), so they are read whole.
 */
export function useRegions(provinceCode: string) {
  const provinces = useProvinces();
  const regencies = useApi<Regency[]>(provinceCode ? regionPaths.regencies(provinceCode) : null);
  return { provinces, regencies };
}

/** The regencies whose name contains every typed word ("kab bandung", "kota bdg" finds nothing, "bandung" both). */
export function filterRegencies(list: readonly Regency[], q: string): Regency[] {
  const words = q.toLowerCase().replace(/\bkab\.?\b/g, 'kabupaten').split(/\s+/).filter(Boolean);
  return words.length ? list.filter((r) => words.every((w) => r.name.toLowerCase().includes(w))) : [...list];
}
